var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpenSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ed7850;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320,32c0-9.9-4.5-19.2-12.3-25.2s-17.9-8.2-27.5-5.8L100.3,46c-21.3,5.3-36.3,24.5-36.3,46.5v355.5h-32c-17.7,0-32,14.3-32,32s14.3,32,32,32h288V32ZM256,256c0,17.7-10.7,32-24,32s-24-14.3-24-32,10.7-32,24-32,24,14.3,24,32ZM352,128h96v352c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32s-14.3-32-32-32h-32V128c0-35.3-28.7-64-64-64h-96v64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenSolid);
export default __webpack_public_path__ + "static/media/door-open-solid.c97a2eef1ae4a07db2cbf52d887849ab.svg";
export { ForwardRef as ReactComponent };